import React from "react";
import { BRAND } from "../config/brand";

// Official logos (public/logo-*.png). Size by height only; width follows the aspect ratio.
export const Logo = ({ variant = "vertical", className = "h-24", testId = "brand-logo" }) => (
  <img
    src={variant === "horizontal" ? BRAND.logoHorizontal : BRAND.logoVertical}
    alt={`${BRAND.fullName} – ${BRAND.tagline}`}
    data-testid={testId}
    className={`w-auto max-w-full object-contain ${className}`}
  />
);

export const LogoMark = ({ className = "w-11 h-11", testId = "brand-logo-mark" }) => (
  <img src={BRAND.logoIcon} alt={BRAND.fullName} data-testid={testId} className={`object-contain ${className}`} />
);
